export const DEFAULT_PAGE = 1
export const PAGE_SIZE = 10
